export default __webpack_public_path__ + "img/simulation-homepage.dfc57fba.svg";